import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Leaf, FlaskConical, Check } from 'lucide-react';

export const TrustSection = () => {
  const trustItems = [
    {
      icon: Shield,
      title: 'Vet Approved',
      desc: 'Developed with veterinary expertise'
    },
    {
      icon: Leaf,
      title: 'Grain Free',
      desc: 'No grains, no fillers'
    },
    {
      icon: FlaskConical,
      title: 'Science-Backed',
      desc: 'Formulated with nutritionists'
    },
    {
      icon: Check,
      title: 'Made in UK',
      desc: 'High-quality ingredients'
    },
  ];

  return (
    <div className="trust-section py-8 mb-8" data-testid="trust-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {trustItems.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: i * 0.1 }}
              className="trust-card"
            >
              <div className="w-12 h-12 rounded-full bg-[#0FA49C]/10 flex items-center justify-center mx-auto mb-3">
                <item.icon className="w-6 h-6 text-[#0FA49C]" />
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};
